export enum BreakpointName {
    Small = "sm",
    Medium = "md",
    Large = "lg",
}

let currentBreakpoint: BreakpointName = "" as BreakpointName
const listeners: Array<(activeBreakpoint: string) => void> = []

export const addBreakpointListener = (callback: (breakpoint: string) => void) => {
    listeners.push(callback)
}

export const getCurrentBreakpoint = () => {
    return currentBreakpoint
}

const breakpoints = [
    { width: 768, name: BreakpointName.Small },
    { width: 992, name: BreakpointName.Medium },
    { width: 1200, name: BreakpointName.Large },
]

function notifyBreakpointListeners() {
    for (const listener of listeners) {
        listener(currentBreakpoint)
    }
}

function switchBreakpoint(mqlEvent: MediaQueryListEvent, breakpointName: BreakpointName) {
    if (mqlEvent.matches && currentBreakpoint !== breakpointName) {
        currentBreakpoint = breakpointName
        notifyBreakpointListeners()
    }
}

function setUpBreakpointNotifier(mql: MediaQueryList, breakpointName: BreakpointName) {
    mql.addEventListener("change", (mqlEvent) => switchBreakpoint(mqlEvent, breakpointName), { passive: true })

    if (mql.matches) {
        currentBreakpoint = breakpointName
    }
}

requestAnimationFrame(() => {
    for (const i in breakpoints) {
        let mql: MediaQueryList
        const breakpointIndex = Number(i)

        const currentEntry = breakpoints[breakpointIndex]
        const nextEntry = breakpoints[breakpointIndex + 1]

        if (breakpointIndex === 0) {
            mql = matchMedia(`(min-width: 0px) and (max-width: ${currentEntry.width - 1}px)`)
            setUpBreakpointNotifier(mql, currentEntry.name)
        }

        if (nextEntry === undefined) {
            mql = matchMedia(`(min-width: ${currentEntry.width}px)`)
            setUpBreakpointNotifier(mql, currentEntry.name)
        } else {
            mql = matchMedia(`(min-width: ${currentEntry.width}px) and (max-width: ${nextEntry.width - 1}px)`)
            setUpBreakpointNotifier(mql, currentEntry.name)
        }
    }
})
